import { BottomSheetComponent, registerBottomSheets } from '@betty/navigation';
import LimitReached from './LimitReachedBottomSheet/LimitReachedBottomSheet';
import ContactSupport from './ContactSupportBottomSheet/ContactSupportBottomSheet';

const bottomSheets = {
  LimitReached,
  ContactSupport,
};

registerBottomSheets('responsibleGaming', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    responsibleGaming: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
